import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// import InvoiceDownloadPage from 'src/components/trainings/InvoiceDownloadPage';
// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);
const ArchiveViewStore = lazy(() =>
import('src/pages/archive/archive').then((module) => ({
  default: module.ArchiveViewStore,
}))
);

// ----------------------------------------------------------------------

export const ArchiveRoutes = [
  {
    path: 'archives',
    element: (
      <AuthGuard allowedRoles={['organization', 'manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <ArchiveViewStore />, index: true },
    ],
  },
];


